import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import InfinityList from '@/components/ui/custom/InfinityList';
import Card from '@/components/projects/cards/Card';
import ProjectCardsFactory from '@/components/projects/cards/factory/ProjectCardsFactory';
import { useRanking } from '@/data/hook/hackathon/useRanking';
import useManualQuery from '@/data/hook/query/v1/useManualQuery';
import { ProjectFilters } from '@/data/services/projectServices';
import Hackathon from '@/models/Hackathon';
import { spring } from '@/utils/animations/commom';
import { motion } from 'motion/react';

type ListHackathonRankingProps = {
  hackathon: Hackathon;
  filters: ProjectFilters;
};

export default function ListHackathonRanking({
  hackathon,
  filters,
}: ListHackathonRankingProps) {
  const {
    restProjects,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isLoading,
    queryKey,
  } = useRanking(hackathon, filters);
  const loadingCards = Array.from({ length: 20 }).map((_, index) => (
    <Card.Skeleton key={index} className="w-full" />
  ));

  const { update } = useManualQuery({ queryKey });

  return (
    <InfinityList
      hasNextPage={hasNextPage}
      onReachEnd={fetchNextPage}
      isFetchingNextPage={isFetchingNextPage}
      className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-2.5 mt-8"
    >
      <ConditionalRenderer condition={!isLoading} fallback={loadingCards}>
        {restProjects.map(project => (
          <motion.div
            key={project.id}
            layout
            transition={spring}
            className="w-full min-w-full xl:min-w-full"
          >
            <ProjectCardsFactory
              project={project}
              key={project.id}
              rank={project.rank}
              onMutate={update}
              mode="ranking"
              className={{
                base: 'w-full min-w-full xl:min-w-full',
              }}
            />
          </motion.div>
        ))}
      </ConditionalRenderer>
    </InfinityList>
  );
}
